// Pincode lookup service for Indian postal codes
export interface PincodeData {
  pincode: string;
  city: string;
  state: string;
  district?: string;
}

// Sample pincode data for common Indian pincodes
// In a real application, you'd use a comprehensive API like PostOffice API or a larger dataset
const PINCODE_DATABASE: Record<string, PincodeData> = {
  '110001': { pincode: '110001', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110002': { pincode: '110002', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110003': { pincode: '110003', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110004': { pincode: '110004', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110005': { pincode: '110005', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110006': { pincode: '110006', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110007': { pincode: '110007', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110008': { pincode: '110008', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110009': { pincode: '110009', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  '110010': { pincode: '110010', city: 'New Delhi', state: 'Delhi', district: 'Central Delhi' },
  
  // Mumbai
  '400001': { pincode: '400001', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400002': { pincode: '400002', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400003': { pincode: '400003', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400004': { pincode: '400004', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400005': { pincode: '400005', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400006': { pincode: '400006', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400007': { pincode: '400007', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400008': { pincode: '400008', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400009': { pincode: '400009', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  '400010': { pincode: '400010', city: 'Mumbai', state: 'Maharashtra', district: 'Mumbai' },
  
  // Bangalore
  '560001': { pincode: '560001', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560002': { pincode: '560002', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560003': { pincode: '560003', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560004': { pincode: '560004', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560005': { pincode: '560005', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560006': { pincode: '560006', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560007': { pincode: '560007', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560008': { pincode: '560008', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560009': { pincode: '560009', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  '560010': { pincode: '560010', city: 'Bangalore', state: 'Karnataka', district: 'Bangalore Urban' },
  
  // Chennai
  '600001': { pincode: '600001', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600002': { pincode: '600002', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600003': { pincode: '600003', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600004': { pincode: '600004', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600005': { pincode: '600005', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600006': { pincode: '600006', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600007': { pincode: '600007', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600008': { pincode: '600008', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600009': { pincode: '600009', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  '600010': { pincode: '600010', city: 'Chennai', state: 'Tamil Nadu', district: 'Chennai' },
  
  // Hyderabad
  '500001': { pincode: '500001', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500002': { pincode: '500002', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500003': { pincode: '500003', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500004': { pincode: '500004', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500005': { pincode: '500005', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500006': { pincode: '500006', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500007': { pincode: '500007', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500008': { pincode: '500008', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500009': { pincode: '500009', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  '500010': { pincode: '500010', city: 'Hyderabad', state: 'Telangana', district: 'Hyderabad' },
  
  // Kolkata
  '700001': { pincode: '700001', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700002': { pincode: '700002', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700003': { pincode: '700003', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700004': { pincode: '700004', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700005': { pincode: '700005', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700006': { pincode: '700006', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700007': { pincode: '700007', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700008': { pincode: '700008', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700009': { pincode: '700009', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  '700010': { pincode: '700010', city: 'Kolkata', state: 'West Bengal', district: 'Kolkata' },
  
  // Pune
  '411001': { pincode: '411001', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411002': { pincode: '411002', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411003': { pincode: '411003', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411004': { pincode: '411004', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411005': { pincode: '411005', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411006': { pincode: '411006', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411007': { pincode: '411007', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411008': { pincode: '411008', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411009': { pincode: '411009', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  '411010': { pincode: '411010', city: 'Pune', state: 'Maharashtra', district: 'Pune' },
  
  // Ahmedabad
  '380001': { pincode: '380001', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380002': { pincode: '380002', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380003': { pincode: '380003', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380004': { pincode: '380004', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380005': { pincode: '380005', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380006': { pincode: '380006', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380007': { pincode: '380007', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380008': { pincode: '380008', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380009': { pincode: '380009', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  '380010': { pincode: '380010', city: 'Ahmedabad', state: 'Gujarat', district: 'Ahmedabad' },
  
  // Meerut (your current user's location)
  '250001': { pincode: '250001', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250002': { pincode: '250002', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250003': { pincode: '250003', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250004': { pincode: '250004', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250005': { pincode: '250005', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250006': { pincode: '250006', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250007': { pincode: '250007', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250008': { pincode: '250008', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250009': { pincode: '250009', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  '250010': { pincode: '250010', city: 'Meerut', state: 'Uttar Pradesh', district: 'Meerut' },
  
  // Jaipur
  '302001': { pincode: '302001', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302002': { pincode: '302002', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302003': { pincode: '302003', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302004': { pincode: '302004', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302005': { pincode: '302005', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302006': { pincode: '302006', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302007': { pincode: '302007', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302008': { pincode: '302008', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302009': { pincode: '302009', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  '302010': { pincode: '302010', city: 'Jaipur', state: 'Rajasthan', district: 'Jaipur' },
  
  // Lucknow
  '226001': { pincode: '226001', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226002': { pincode: '226002', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226003': { pincode: '226003', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226004': { pincode: '226004', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226005': { pincode: '226005', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226006': { pincode: '226006', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226007': { pincode: '226007', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226008': { pincode: '226008', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226009': { pincode: '226009', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  '226010': { pincode: '226010', city: 'Lucknow', state: 'Uttar Pradesh', district: 'Lucknow' },
  
  // Kanpur
  '208001': { pincode: '208001', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208002': { pincode: '208002', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208003': { pincode: '208003', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208004': { pincode: '208004', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208005': { pincode: '208005', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208006': { pincode: '208006', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208007': { pincode: '208007', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208008': { pincode: '208008', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208009': { pincode: '208009', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
  '208010': { pincode: '208010', city: 'Kanpur', state: 'Uttar Pradesh', district: 'Kanpur Nagar' },
};

/**
 * Lookup city and state information by pincode
 * @param pincode - 6-digit Indian postal code
 * @returns Promise<PincodeData | null> - City and state information or null if not found
 */
export const lookupPincode = async (pincode: string): Promise<PincodeData | null> => {
  // Validate pincode format (6 digits)
  const cleanPincode = pincode.replace(/\D/g, ''); // Remove non-digits
  if (cleanPincode.length !== 6) {
    return null;
  }

  // Check local database first
  const localResult = PINCODE_DATABASE[cleanPincode];
  if (localResult) {
    return localResult;
  }

  // In a real application, you would call an external API here
  // For example: PostOffice API, India Post API, or other pincode services
  try {
    // Example of how you might call an external API:
    // const response = await fetch(`https://api.postalpincode.in/pincode/${cleanPincode}`);
    // const data = await response.json();
    // if (data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
    //   const postOffice = data[0].PostOffice[0];
    //   return {
    //     pincode: cleanPincode,
    //     city: postOffice.District || postOffice.Name,
    //     state: postOffice.State,
    //     district: postOffice.District
    //   };
    // }
    
    // For now, return null if not found in local database
    return null;
  } catch (error) {
    console.error('Error fetching pincode data:', error);
    return null;
  }
};

/**
 * Validate if a pincode is in correct Indian format
 * @param pincode - Pincode to validate
 * @returns boolean - True if valid format
 */
export const isValidPincode = (pincode: string): boolean => {
  const cleanPincode = pincode.replace(/\D/g, '');
  return cleanPincode.length === 6 && /^[1-9][0-9]{5}$/.test(cleanPincode);
};

/**
 * Get formatted pincode (6 digits with proper formatting)
 * @param pincode - Pincode to format
 * @returns string - Formatted pincode
 */
export const formatPincode = (pincode: string): string => {
  const cleanPincode = pincode.replace(/\D/g, '');
  if (cleanPincode.length <= 6) {
    return cleanPincode;
  }
  return cleanPincode.substring(0, 6);
};
